import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-actionbar-layout',
  standalone: true,
  imports: [CommonModule, ButtonModule, RouterModule],
  templateUrl: './actionbar-layout.component.html',
  styleUrls: ['./actionbar-layout.component.scss'],
})
export class ActionbarLayoutComponent {
  @Input() title?: string;
  @Input() buttonsTemplate?: TemplateRef<any>;
  @Input() contentTemplate?: TemplateRef<any>;
  @Input() toolbarClass: string = '';
  @Input() contentClass: string = '';
  @Input() defaultBackRoute: string = '/';
  @Input() showBackButton: boolean = true;
  @Output() contentScroll = new EventEmitter<Event>();

  constructor(private navigationService: NavigationService) {}

  goBack(): void {
    this.navigationService.back(this.defaultBackRoute);
  }

  onContentScroll(event: Event): void {
    this.contentScroll.emit(event);
  }
}
